import React from 'react';
import { PanelTop, Fan, Sun, Shirt, PawPrint, AppWindow, Utensils, Trash2, PartyPopper, Package, Minus, Plus } from 'lucide-react';
import { formatMoney } from './calc';

const ICONS = {
  blinds: PanelTop,
  ceiling_fans: Fan,
  balcony_terrace: Sun,
  personal_laundry: Shirt,
  pet_hair: PawPrint,
  interior_windows: AppWindow,
  dishwasher_interior: Utensils,
  trash_can_sanitizing: Trash2,
  post_party: PartyPopper,
  move_in_out: Package,
};

const ExtrasStep = ({ config, draft, updateDraft, nextStep, prevStep }) => {
  const addOns = draft.add_ons || {};

  const toggle = (key) => {
    const next = { ...addOns };
    if (next[key] !== undefined) delete next[key];
    else next[key] = 1;
    updateDraft({ add_ons: next });
  };

  const setQty = (key, qty) => {
    updateDraft({ add_ons: { ...addOns, [key]: Math.max(1, Math.min(50, qty)) } });
  };

  return (
    <div className="form-step" data-testid="extras-step">
      <h2 className="step-title">Add-Ons & Extras</h2>
      <p className="step-description">Optional extras to customize your cleaning</p>

      <div className="addon-tiles" data-testid="addon-tiles">
        {config.add_ons.map((addon) => {
          const Icon = ICONS[addon.key] || Package;
          const selected = addOns[addon.key] !== undefined;
          return (
            <div
              key={addon.key}
              className={`addon-tile ${selected ? 'selected' : ''}`}
              onClick={() => toggle(addon.key)}
              data-testid={`addon-${addon.key}`}
            >
              <div className="addon-tile-icon"><Icon size={20} strokeWidth={1.5} /></div>
              <span className="addon-tile-name">{addon.label}</span>
              <span className="addon-tile-price">
                {addon.starting_at ? 'from ' : ''}+{formatMoney(addon.price)}
                {addon.per_unit ? ` / ${addon.per_unit}` : ''}
              </span>
              {selected && addon.per_unit && (
                <div className="addon-qty" onClick={(e) => e.stopPropagation()} data-testid={`addon-qty-${addon.key}`}>
                  <button type="button" className="qty-btn" onClick={() => setQty(addon.key, addOns[addon.key] - 1)} data-testid={`addon-qty-minus-${addon.key}`}>
                    <Minus size={14} />
                  </button>
                  <span className="qty-value">{addOns[addon.key]}</span>
                  <button type="button" className="qty-btn" onClick={() => setQty(addon.key, addOns[addon.key] + 1)} data-testid={`addon-qty-plus-${addon.key}`}>
                    <Plus size={14} />
                  </button>
                </div>
              )}
            </div>
          );
        })}
      </div>

      <div className="form-actions">
        <button type="button" className="btn btn-secondary" onClick={prevStep} data-testid="extras-step-back">
          Back
        </button>
        <button type="button" className="btn btn-primary" onClick={nextStep} data-testid="extras-step-next">
          Continue
        </button>
      </div>
    </div>
  );
};

export default ExtrasStep;
